export default __webpack_public_path__ + "static/media/purchase-new.a2b88b85.png";